<template>
  <div>
    <H4>One moment while we generate your report.</H4><br><br>
    <p>Be sure to print out your final staff and participant rosters.</p>
    <div
      id="theReport"
      v-show="false"
    >
      <Printer title="Course Director's Closeout">
        <template v-slot:printContent>
          <report-closeout-coversheet
            :report-info="reportInfo"
          />
          <report-participant-by-position />
          <report-closeout-recommendations-staff
            :header-info="reportInfo.Header"
            :staff="staff"
          />
          <report-closeout-recommendations-participant
            :participants="participants"
          />
          <report-closeout-uncertified-participants />
        </template>
      </Printer>
    </div>
  </div>
</template>

<script>
import ReportCloseoutCoversheet from '@/components/reports/closeout/print/report-closeout-coversheet.vue'
import ReportParticipantByPosition from '@/components/reports/closeout/print/report-participant-by-position.vue'
import ReportCloseoutRecommendationsStaff from '@/components/reports/closeout/print/report-closeout-recommendations-staff.vue'
import ReportCloseoutRecommendationsParticipant from '@/components/reports/closeout/print/report-closeout-recommendations-participant.vue'
import ReportCloseoutUncertifiedParticipants from '@/components/reports/closeout/print/report-closeout-uncertified-participants.vue'
import recommendationApi from '@/services/api/recommendation.js'
import reportsApi from '@/services/api/reports.js'
import Printer from '@/components/_main/printer.vue'

// import HtmlToPaperTest from '@/plugins/vue-html-to-paper-test.js'

export default {
  name: 'ReportCloseoutGenerator',
  components: {
    ReportCloseoutCoversheet,
    ReportParticipantByPosition,
    ReportCloseoutRecommendationsStaff,
    ReportCloseoutRecommendationsParticipant,
    ReportCloseoutUncertifiedParticipants,
    Printer
  },
  data: function () {
    return {
      staff: [],
      participants: [],
      reportInfo: {
        Header: {},
        CourseDirector: {},
        CourseComments: {},
        ScouterCount: {},
        FirstTimeStaffMembers: []
      },
      showPrint: false,
      loading: true
    }
  },
  watch: {
    loading: function (newValue) {
      if (!newValue) {
        this.showReport()
      }
    }
  },
  mounted: function () {
    this.getCoverSheet()
  },
  methods: {
    showReport: function () {
      const printOptions = {
        styles: [
          '/kidlat.css',
          '/bootstrap.min.css',
          '/chalk-theme.css',
          '/printer-styles/two-beads-print.css',
          '/printer-styles/header-footer.css',
          '/printer-styles/closeout.css'
        ]
      }

      this.$nextTick(function () {
        if (this.printItem !== '') {
          this.$htmlToPaper('theReport', printOptions)
        }
        this.printItem = ''
      })
    },
    getCoverSheet: function () {
      reportsApi
        .getCloseoutCoversheet(this.$root.courseKey)
        .then(response => {
          this.reportInfo = response
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.getStaff()
        })
    },
    getStaff: function () {
      recommendationApi
        .getStaff(this.$root.courseKey)
        .then(x => {
          this.staff = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.getParticipant()
        })
    },
    getParticipant: function () {
      recommendationApi
        .getParticipant(this.$root.courseKey)
        .then(x => {
          this.participants = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
